import type {EditorState, Transaction} from "prosemirror-state";
import type {EditorView} from "prosemirror-view";

import {TriggerActionCommandAdditionalParams} from "./types";
import {uploadImageWithProgressBar} from "../../../utils/files/uploadImageWithProgressBar";

export const uploadImageCommand  = (state: EditorState, dispatch?: (tr: Transaction) => void, view?: EditorView, additionalParams?: TriggerActionCommandAdditionalParams) => {
    if (!view) {
        return true;
    }

    // Get services from app integration
    const appIntegration = state.schema.cached.app;
    if (!appIntegration) {
        console.error('No app integration available for image upload');
        return true;
    }

    const serviceRegistry = appIntegration.appState.getServiceRegistry();
    const storageService = serviceRegistry.getStorageService();
    const tenantId = appIntegration.appState.userState?.tenantId;
    const fileProvider = appIntegration.appState.userState?.fileProvider;
    
    if (!tenantId || !fileProvider) {
        console.error('No tenant ID or file provider available for image upload');
        return true;
    }

    fileProvider.uploadImage(
        {multiple: false},
        (files: FileList | null) => {
            if (files?.length) {
                const file = files[0];
                if (additionalParams && additionalParams.nodePos !== undefined && additionalParams.textInput !== undefined) {
                    const length = additionalParams.textInput.length + 1 /* textInput doesn't count first trigger letter */;
                    uploadImageWithProgressBar(view, file, storageService, tenantId, additionalParams.nodePos, length);
                } else {
                    uploadImageWithProgressBar(view, file, storageService, tenantId, state.selection.$from);
                }
            }
        }
    );
    return true;
}
